export interface InvoiceContentProps {
  size?: InvoiceContentSize;
  className: string;
}

export enum InvoiceContentSize {
  MEDIUM = 'medium',
  SMALL = 'small',
}
